export const SWITCH_LANG = "SWITCH_LANG";

export const switchLang = lang => {
  return dispatch => {
    dispatch({ type: SWITCH_LANG, payload: {lang: lang} });
  };
};